import { css } from 'emotion';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';
import chroma from 'chroma-js';
import { animationTransition } from '@joykit/variables';

export namespace styles {
  export const container = css({});

  export const deviceWrapper = css({
    height: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    top: 0,
    width: '100%'
  });

  export const devicesContainer = (mobile: boolean) =>
    css({
      display: 'flex'
    });

  export const deviceButton = css({
    cursor: 'pointer',
    background: 'none',
    borderStyle: 'none',
    padding: '0',
    font: 'inherit',
    outline: 'inherit',
    paddingRight: '1px',
    ':not(:last-child)': {
      marginRight: 32
    }
  });

  export const filterButton = (active: boolean) =>
    css({
      padding: '8px 32px',
      backgroundColor: '#333',
      color: 'white',
      letterSpacing: '.3px',
      marginRight: '32px',
      ...getInterUIDynamicMetricCssObject(14),
      transition: animationTransition('background-color'),
      ':hover': {
        backgroundColor: chroma('#333')
          .darken()
          .css()
      }
    });

  export const startButton = (color: string) => {
    const backgroundColor = (value: number) =>
      chroma(color)
        .darken(value)
        .css();
    return css({
      position: 'absolute',
      right: '40px',
      padding: '16px',
      backgroundColor: backgroundColor(0.4) || '#E1BBAD',
      ...getInterUIDynamicMetricCssObject(15),
      color: 'white',
      fontWeight: 'bold',
      transition: animationTransition('background-color'),
      ':hover': {
        backgroundColor: backgroundColor(0.8)
      }
    });
  };
}
